import { NgModule } from 'angular-ts-decorators';

import { moduleName } from '../constants';

import { HeroCustomizerV3TotalsComponent } from './hero-customizer-v3-totals.component';

@NgModule({
  declarations: [
    HeroCustomizerV3TotalsComponent,
  ],
  id: `${moduleName}.totals`,
  providers: [],
})
export class HeroCustomizerV3TotalsModule {
}
